<template>
  <div class="float-warning-container" v-if="warningMessages.length">
    <el-carousel height="34px" indicator-position="none" arrow="never">
      <el-carousel-item
        v-for="(item, index) in warningMessages"
        :key="item.msg + index">
        <el-alert
          :title="item.msg"
          :closable="false"
          :type="item.type">
        </el-alert>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { isLowVoltage } from '@/utils/helpers';

export default {
  props: ['deviceStates'],
  data() {
    return {
      currentIndex: 0,
    };
  },
  computed: {
    warningMessages() {
      // 超预警、丢数据、欠压
      return this.deviceStates.filter((state) => {
        const { exceedState, collectState } = state;
        return !exceedState || !collectState || isLowVoltage(state);
      }).map((state) => {
        const {
          deviceName, exceedState, exceedValue, exceedThreshold, collectState,
        } = state;

        let type = 'warning';
        const msgList = [];
        if (!exceedState) {
          type = 'error';
          msgList.push(`超预警（当前值：${+exceedValue.toFixed(3)}，预警值：${exceedThreshold}）`);
        }
        if (!collectState) {
          msgList.push('采集丢失');
        }
        if (isLowVoltage(state)) {
          msgList.push('电压不足');
        }
        return { type, msg: `设备『${deviceName}』报警：${msgList.join('、')}！` };
      });
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.float-warning-container {
  margin-bottom: 10px;
}
@media screen and (max-width: 992px) {
  .float-warning-container {
    position: fixed;
    bottom: 0;
    width: 100%;
    margin-bottom: 0;
    z-index: 9;
  }
}
</style>
